//
//
//
//
//

export default {
	name: "Legal",
	props: ["text", "margin"]
}
